import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const usePages = () => {
    const { pathname } = useLocation();

    const isSelectedCandidates: boolean = useMemo(() => {
        return pathname.includes("selected-candidates")
    }, [pathname]);	

    const isRanking: boolean = useMemo(() => {
        return pathname.includes("ranking")
    }, [pathname]);

    const isTrack: boolean = useMemo(() => {
        return pathname.includes("track")
    }, [pathname]);

    return {
        isSelectedCandidates,
        isRanking,
        isTrack
    };
};

export default usePages;
